import { KibsiClientParams } from '@kibsi/ks-client-sdk'
import { Environment } from 'config/environment'
import logger from 'logging/logger'

import { UiKibsiClientSdk } from '../ui'

export type KibsiAPI = UiKibsiClientSdk

export function createKibsiApiClient(env: Environment, config?: Partial<KibsiClientParams>): UiKibsiClientSdk {
    return new UiKibsiClientSdk({
        ...config,
        basePathTemplate: env.serviceUrl,
        logger,
    })
}
